<script lang="ts" setup>
import {onUnmounted, ref} from "vue";
import SearchInput from "@src/components/ui/inputs/SearchInput.vue";
import SidebarHeader from "@src/components/views/HomeView/Sidebar/SidebarHeader.vue";
import {useGroups} from "@src/composables/useGroups";
import NoConversation from "@src/components/states/empty-states/NoConversation.vue";
import GroupItem from "@src/components/shared/group/GroupItem.vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import NotifyToggle from "@src/components/ui/inputs/NotifyToggle.vue";
import InformationIcon from "@src/components/ui/utils/InformationIcon.vue";
import StartConversationModal from "@src/components/shared/modals/StartConversationModal/StartConversationModal.vue";
import WaapiCampaign from "@src/components/shared/modals/WaapiCampaignModal/WaapiCampaign.vue";
import {useWAAPIStore} from "@src/stores/waapi";

const search = ref('');
const sessionStore = useChatSessionStore()
const {getGroups} = useGroups();

const groups = getGroups(search);
const costumerToken = ref('');
const waapiStore = useWAAPIStore()

onUnmounted(() => {
    sessionStore.clearSession()
})
const closeComposeModal = () => {
    sessionStore.openStartConversationModal = false;
    sessionStore.selectedCostumer = {
        id: 0,
        name: '',
        token: ''
    }
};

const openWaapiModal = (value: string) => {
    costumerToken.value = value
    sessionStore.clearSession()
    waapiStore.showCampaignModal = true
}

</script>

<template>
    <div>
        <SidebarHeader>
            <!--title-->
            <template v-slot:title>
                Grupos
                <InformationIcon class="mb-2" text="Visualize e participe dos seus grupos no Whatsapp"
                                 title="Grupos"></InformationIcon>
            </template>
            <template v-slot:actions>
                <div class="flex items-center">
                    <NotifyToggle type="groups"/>
                </div>
            </template>
        </SidebarHeader>

        <!--search bar-->
        <div class="px-5 xs:pb-6 md:pb-5">
            <SearchInput
                :value="search"
                @value-changed="value => search = value"
            />
        </div>

        <div v-if="groups.length > 0" class="flex w-full text-center mb-4">
            <h1 class="w-full heading-2 text-gray-400">{{ groups.length }} grupos ativos</h1>
        </div>
        <!--conversations-->
        <div
            aria-label="conversations"
            class="w-full h-full scroll-smooth scrollbar-hidden"
            role="list"
            style="overflow-x: visible; overflow-y: scroll"
        >

            <div v-if="groups && groups.length > 0" class="h-full overflow-y-auto scrollbar-thin">
                <GroupItem
                    v-for="group in groups"
                    :id="group.id"
                    :key="group.id"
                    :has-new-message="(group.unread_count ?? 0) > 0"
                    :is-community="group.is_community"
                    :last-message="group.last_message"
                    :last-message-date="group.last_message_date"
                    :picture="group.picture"
                    :subject="group.subject"
                    @click="sessionStore.selectSession(group)"
                />
            </div>

            <div v-else>
                <NoConversation message="Tente alterar seus critérios de busca..." title="Nenhum grupo encontrado"/>
            </div>

        </div>
        <Teleport v-if="sessionStore.openStartConversationModal" to="#modal-root">
            <StartConversationModal :close-modal="closeComposeModal"
                                    :open="sessionStore.openStartConversationModal"
                                    @token="openWaapiModal"/>
        </Teleport>

        <Teleport v-if="waapiStore.showCampaignModal" to="#modal-root">
            <WaapiCampaign :costumer-token="costumerToken"/>
        </Teleport>
    </div>
</template>
